import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { Field, Input } from "@fluentui/react-components";
import PropTypes from 'prop-types';

const FieldLookupOptions = ({ fieldValues, setFieldValues, setFieldType, disabled }) => {

    const lookupChange = (value, lookupIndex) => {
        setFieldValues({ ...fieldValues, LookupValues: fieldValues.LookupValues.map((lookup, lidx) => lookupIndex === lidx ? value : lookup) });
    }

    const addLookup = () => {
        setFieldValues({ ...fieldValues, LookupValues: [...fieldValues.LookupValues, ""] });
    }

    const removeLookup = (lookupIndex) => {
        setFieldValues({ ...fieldValues, LookupValues: fieldValues.LookupValues.filter((_, idx) => lookupIndex !== idx) });
    }

    const switchToDropdown = () => {
        setFieldType({ value: 'Dropdown', label: 'Dropdown', description: 'Select one option from a menu', icon: 'ChevronCircleDownRegular' });
    }

    return (
        <div>
            <Field label="Options" size="medium" />
            {fieldValues.LookupValues?.map((lookup, lookupIndex) => {
                return <Form.Group className="option-input" key={lookupIndex}>
                    <Input
                        value={lookup}
                        onChange={(e) => lookupChange(e.target.value, lookupIndex)}
                        placeholder={`Option ${lookupIndex + 1}`}
                        disabled={disabled}
                    />
                    {
                        lookupIndex > 1 ?
                            <Button
                                data-testid="delete"
                                className="btn-icon1 delete"
                                onClick={() => removeLookup(lookupIndex)}
                                type="button"
                                disabled={disabled}
                            />
                            :
                            <Button
                                className="btn-icon1 no-delete"
                                disabled
                                type="button"
                            />
                    }
                </Form.Group>
            })}

            <Form.Group className="option-input">
                {
                    fieldValues.FieldType === "Radio Buttons" && fieldValues.LookupValues?.length > 4 ?
                        <Button
                            onClick={() => switchToDropdown()}
                            disabled={disabled}
                        >
                            Switch to Dropdown
                        </Button>
                        :
                        <Button onClick={() => addLookup()} disabled={disabled}>
                            + Add option
                        </Button>
                }
            </Form.Group>
        </div>
    );
}

FieldLookupOptions.propTypes = {
    fieldValues: PropTypes.shape({
        LookupValues: PropTypes.arrayOf(PropTypes.string),
        FieldType: PropTypes.string,
    }).isRequired,
    setFieldValues: PropTypes.func.isRequired,
    setFieldType: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
};

export default FieldLookupOptions;